export const APP_CONFIG = {
  URL: {
    apiBasePath: `https://${location.host.includes('localhost') || location.host.includes('365euro365') ? 'eccoplay365.com' : location.host}/`,
  },
};

export const getHeaders = () => {
  return {
    "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  }
}
